export default "__VITE_ASSET__CaNlZhbm__"